a.s.growl = (function(){
	return {
		create:function(title,txt,o){
			var duration = o.duration || 2000;
			if(!document.getElementById('growlc')){
				$('body').append('<div id="growlc"></div>');
			}
			var token = a.s.createToken();
			var c = '<div class="notification" id="growl_notif_'+token+'">';
			c += '<i class="close fa fa-times-circle" data-action="remove_growl_notification"></i>';
			c += '<h5>'+title+'</h5>';
			if (txt) {
				c += '<p>'+txt+'</p>';
			}
			c += '</div>';
			$('#growlc').append(c);
			var win = $('#growl_notif_'+token);
			win.fadeIn(200,function(){
				$('i[data-action="remove_growl_notification"]',win).unbind('click').click(function(){
					a.s.growl.remove(token);
				});
				setTimeout(function(){
					a.s.growl.remove(token);
				},duration);
			});
		},
		remove:function(token){
			var win = $('#growl_notif_'+token);
			win.fadeOut(200,function(){
				win.remove();
				if ($('#growlc>div.notification').length == 0) {
					$('#growlc').remove();
				}
			});
		}
	}
}());